// Payload written by the notification producers, keyed by the row's Code.
// All fields optional — writers omit what they couldn't resolve, and FOR
// JSON drops SQL NULLs.
export type StaffNotificationPayload = {
  // SelfServiceInviteCreated (v2-account-service notifyStaffOfInvite): the
  // invite facts plus the customer's seat math as it stood right after the
  // invitation (e.g. no seat math when the tenant has no customer).
  inviteeEmail?: string
  inviterName?: string
  tenantName?: string
  userCount?: number
  pendingInvitationCount?: number
  userLicenses?: number
  licensesExceeded?: boolean
  // The Customer* threshold alerts (api.Evaluate_Acc_StaffAlerts): the
  // usage/trial/payment numbers as they stood at evaluation time.
  seatCount?: number
  activeCount?: number
  licensedSeats?: number
  weighted28d?: number
  weightedPrev28d?: number
  trendPct?: number
  billed12M?: number
  currency?: string
  overdueBalance?: number
  outstandingBalance?: number
  /** YYYY-MM-DD */
  trialEndsAt?: string
  // CustomerLicenseDemand: the license refusals of the last 7 days as they
  // stood at evaluation time (acc.LicenseDeniedDaily, AIP-47).
  attempts7d?: number
  users7d?: number
  features7d?: number
  topFeatureCode?: string
  topFeatureName?: string
  topFeatureAttempts?: number
  /** Products the refusals happened in, comma-separated ('v2-console, mcp-placepoint'). */
  appCodes?: string
}

export function parseNotificationPayload(
  payload: string | null | undefined,
): StaffNotificationPayload | null {
  if (!payload) return null
  try {
    return JSON.parse(payload) as StaffNotificationPayload
  } catch {
    return null
  }
}
